<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN
    };
  }
};
</script>
<style>
#app {
  min-width: 1080px;
}
.font16 {
  font-size: 16px;
}
.font15 {
  font-size: 15px;
}
.flex {
  display: flex;
}
.w100 {
  width: 100%;
}
.w50 {
  width: 50%;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.bold {
  font-weight: bold;
}
.bolder {
  font-weight: bolder;
}
.justify-center {
  justify-content: center;
}
.align-items {
  align-items: center;
}
.ml10 {
  margin-left: 10px;
}
.mr10 {
  margin-right: 10px;
}
.flex-end {
  justify-content: flex-end;
}
.space-between {
  justify-content: space-between;
}
</style>
